import axios from 'axios';
import { config } from '../config/env';

const API_BASE_URL = config.API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors and standardize responses
api.interceptors.response.use(
  (response) => {
    // Standardize the response structure
    if (response.data && typeof response.data === 'object') {
      return {
        ...response,
        data: response.data.data || response.data,
        message: response.data.message,
        success: response.data.success,
        meta: response.data.meta,
      };
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data without page reload
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      // Use router navigation instead of window.location
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
